import React from 'react'
import { formatLocalDate } from '../../utils/time'
import CardImageShow from '../CertShow/CertShow'
import { useHistory } from 'react-router-dom'
import { getCoverImagePath } from '../../services/utilities'
import { strToBool, UClick } from '../common/utils'

import styles from './CertList.module.css'
import { isMainlandUser } from '../../utils/user'
import { Button } from 'antd-mobile-v5'
import { useSelector } from 'react-redux'
import { getUserInfo } from '../../reducers/selectors'

const BTN_TEXT = {
  BUY_CARD: '点击获取精美卡面',
  VIEW_DETAIL: '点击查看详情',
}

const CardButton = ({ from, visitStatus, cert }) => {
  const { userInfo } = useSelector((state) => ({
    userInfo: getUserInfo(state),
  }))
  const { push } = useHistory()
  const firseVisit = strToBool(visitStatus)
  const isMainland = isMainlandUser(userInfo)
  const shouldShowDetailBtn = firseVisit && !!from
  const shouldShowBuyCardBtn = !shouldShowDetailBtn && isMainland

  const handleBuyCard = () => {
    UClick('clickBuyCardsGroupBCHNA2502')
    setTimeout(() => {
      push('/buy_cards')
    }, 800)
  }

  const handleViewDetail = () => {
    UClick('clickDetailCardsGroupBCHNA2502')
    setTimeout(() => {
      let url =
        cert.type === 'CREDENTIAL'
          ? `/cert/credential/${encodeURIComponent(cert.uniqueId)}`
          : `/cert/certificate/${cert.studentNumber}`

      const path = document.location.pathname
      if (path === '/members' || path === '/ecards') {
        url += '?no_nav'
      }
      push(url)
    }, 800)
  }

  return (
    <>
      {/* 展示购买卡面按钮 */}
      {shouldShowBuyCardBtn && (
        <Button size="mini" color="primary" onClick={handleBuyCard} className={styles['buy-card-btn']}>
          {BTN_TEXT.BUY_CARD}
        </Button>
      )}

      {/* 展示查看详情按钮 */}
      {shouldShowDetailBtn && (
        <Button size="mini" color="primary" onClick={handleViewDetail} className={styles['buy-card-btn']}>
          {BTN_TEXT.VIEW_DETAIL}
        </Button>
      )}
    </>
  )
}

const CertItem = ({ ecard, userInfo, visitStatus }) => {
  const { push } = useHistory()
  const coverImgPath = getCoverImagePath(ecard)

  // 点击获取精美卡面
  const gotoBuyCards = () => {
    UClick('ToBuyCards')
    push('/buy_cards')
  }

  return (
    <div className={styles['cert-box']}>
      <div className={styles['date-box']}>
        <div className={styles.icon}>
          <div className={styles.point}></div>
        </div>
        <div className={styles.date}>{formatLocalDate(ecard.issueDate)}</div>
      </div>
      <div className={styles['card-box']}>
        <CardButton from={'list'} visitStatus={visitStatus} cert={ecard} />
        <div className="card-wrapper">
          <CardImageShow path={coverImgPath} cert={ecard} from={'list'} visitStatus={visitStatus} />
        </div>
      </div>
    </div>
  )
}

export default CertItem
